const getters = {
  registration_button: state => state.registration_button,
};

export default getters;
